export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'surface',
		label: 'Surface Area',
		selector: '& .surface'
	},
	{
		name: 'quoteText',
		label: 'Quote Text',
		selector: '& .quote-text'
	},
	{
		name: 'authorImage',
		label: 'Author Image',
		selector: '& .avatar-image img'
	},
	{
		name: 'authorText',
		label: 'Author Name',
		selector: '& .avatar-text .text'
	},
	{
		name: 'authorDescription',
		label: 'Author Description',
		selector: '& .avatar-text .subtext'
	}
]